import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { UserDetailsForm } from './use-user-details.form';

export const useUserDetailsFormContext = ():
  | UseFormReturn<UserDetailsForm>
  | never => {
  const form = useFormContext<UserDetailsForm>();

  if (form === null)
    throw AppError.hookScopeError('useUserDetailsFormContext error.');

  return form;
};
